import Meta from '../../../Commons/Components/Meta';
import Main from '../../../Commons/Layouts/Main';
import { FormattedMessage } from 'react-intl';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { GET } from '../../../Commons/Utils/fetch';
import dayjs from 'dayjs';
import Pagination from '../../../Commons/Components/Pagination';
import queryString from 'query-string';
import { AttachFileOutlined } from '@mui/icons-material';
import { useMediaQuery } from 'react-responsive';

const metaInfo = {
  title: '공지사항 | 엔터테인먼트 미디어 취업 엔터잡에듀',
  description: '엔터테인먼트 미디어 취업 정보 및 강의를 제공하는 엔터잡에듀의 공지사항입니다.',
};

const Notice = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const history = useHistory();
  const { target } = useParams();
  const { page = 1 } = queryString.parse(location.search);

  const [isLoaded, setIsLoaded] = useState(false);
  const [listCount, setListCount] = useState(0);
  const [list, setList] = useState([]);
  const [topListCount, setTopListCount] = useState(0);
  const [detail, setDetail] = useState({});
  const [currentPage, setCurrentPage] = useState(+page);
  const readPostLogs = JSON.parse(localStorage.getItem('post_view_logs') || '{}');
  const readPostIds = Object.entries(readPostLogs).map(([key, value]) => key);

  const fetchList = async () => {
    const { page = 1 } = queryString.parse(location.search);
    return await GET({
      url: '/auth/posts',
      params: {
        boardCode: 'notice',
        page,
      },
    });
  };
  const fetchDetail = async (id) => {};

  const fetchData = useCallback(async () => {
    // 목록 획득
    const { success, data } = await fetchList();
    if (success) {
      const { count, topPosts, posts } = data;
      setListCount(count);
      setList([...topPosts, ...posts]);
      setTopListCount(topPosts.length);
      setIsLoaded(true);
    }
    if (+target > 0) {
      // 상세 획득
      const noticeDetail = await fetchDetail(target);
      setDetail(noticeDetail);
    }
  }, [target, page]);

  useEffect(() => {
    fetchData();
  }, [target, page]);

  return (
    <Main>
      <Meta metaInfo={metaInfo} />
      <style jsx="true">{`
        #notice-list-container {
          width: 100%;
          max-width: 1200px;
          margin: 0 auto;
          box-sizing: border-box;
          padding: 2.625rem 0 8rem;
          display: flex;
          flex-direction: column;
          row-gap: 2.5rem;
        }

        #notice-list-container h2 {
          font-size: 1.5rem;
          letter-spacing: -0.4px;
          color: #000000;
          font-weight: bold;
        }

        #notice-list-wrap {
          width: 100%;
          display: flex;
          flex-direction: column;
          row-gap: 1.25rem;
        }

        #notice-list {
          width: 100%;
          min-height: 910px;
          display: flex;
          flex-direction: column;
          list-style: none;
          padding: 0;
          margin: 0;
          user-select: none;
        }

        #notice-list li {
          width: 100%;
          height: 100%;
          border-bottom: 1px solid #e5e5e5;
          overflow: hidden;
        }

        #notice-list li a,
        #notice-list li.notice-list-header {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          padding: 1.25rem 0.5rem 1rem;
          transition: background-color 0.2s ease-in-out;
          text-align: center;
          height: 4rem;
          vertical-align: middle;
        }

        #notice-list li a span,
        #notice-list li.notice-list-header span {
          max-height: 3rem;
          line-height: 1.5rem;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        #notice-list li.notice-list-header {
          font-weight: bold;
          background-color: #f5f5f5;
          border-radius: 0.5rem 0.5rem 0 0;
        }

        .title-wrap {
          width: 100%;
          max-width: 60%;
          display: flex;
        }

        span.new-notice {
          display: inline !important;
          margin-left: 0.5rem;
          font-size: 0.75rem;
          font-weight: bold;
          animation: colorChange 1.7s ease-in-out infinite alternate;
        }

        @keyframes colorChange {
          0% {
            color: #f24462;
          }
          50% {
            color: rgba(255, 59, 59, 0.2);
          }
          100% {
            color: #f24462;
          }
        }

        span.read-notice {
          color: rgba(162, 162, 162, 0.6);
          animation: none;
        }

        .date-wrap {
          width: 40%;
        }

        .file-wrap {
          width: 6rem;
        }

        .notice-title {
          text-align: left;
          padding: 0 1.25rem;
        }

        .top-notice-title {
          font-weight: bold;
        }

        #notice-list li a:hover {
          background-color: #f5f5f5;
        }

        #notice-list li:last-child {
          border-bottom: none;
        }

        #notice-pagination {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          column-gap: 0.5rem;
        }

        #notice-pagination li {
          min-width: 2rem;
          height: 2rem;
          border-radius: 1rem;
          font-size: 0;
          overflow: hidden;
          cursor: pointer;
          padding: 0.5rem;
        }

        #notice-pagination li:hover {
          background-color: #e5e5e5;
        }

        #notice-pagination li a {
          width: 100%;
          height: 100%;
          font-size: 1rem;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 0.125rem;
        }

        .top-notice-pin-wrap {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 2rem;
          height: 2rem;
        }

        @media screen and (max-width: 768px) {
          #notice-list-container {
            padding: 1.5rem 1rem 8rem;
            row-gap: 1rem;
          }

          #notice-list-container h2 {
            font-size: 1.25rem;
          }

          #notice-list-wrap #notice-list li.notice-list-header {
            display: none;
          }

          #notice-list-wrap #notice-list li a {
            display: flex;
            flex-wrap: nowrap;
            column-gap: 0.25rem;
            padding: 1rem 0.25rem 0.75rem;
            justify-content: space-between;
          }

          #notice-list-wrap #notice-list li a span {
            width: auto;
            min-width: 20%;
            text-align: left;
            white-space: nowrap;
            font-size: 0.875rem;
            padding: 0;
            height: 100%;
          }

          #notice-list-wrap #notice-list li a span.notice-title {
            text-align: left;
            width: 60%;

            max-height: 2.5rem;
            line-height: 1.25rem;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;

            word-break: break-all;
            white-space: normal;
            overflow: hidden;
          }

          #notice-list-wrap #notice-list li a span.notice-date {
            color: #999999;
            font-size: 0.75rem;
          }

          #notice-list-wrap #notice-list li a span.notice-file {
            color: #999999;
            font-size: 0.75rem;
            min-width: 20px;
          }

          #notice-list {
            min-height: 0;
          }
        }
      `}</style>
      <div id="notice-list-container">
        <div id="notice-title-wrap">
          <h2>
            <FormattedMessage id="HEADER_USER_NAV_NOTICE" />
          </h2>
        </div>
        <div id="notice-list-wrap">
          <ol id="notice-list">
            <li className="notice-list-header">
              <span className="title-wrap">제목</span>
              <span className="date-wrap">작성일</span>
              <span className="file-wrap">첨부파일</span>
            </li>
            {list.map((item, index) => (
              <li id={`notice-${item.id}`} key={index}>
                <Link to={`/notice/${item.id}?page=${currentPage}`}>
                  <div className="top-notice-pin-wrap">{index < topListCount && <span>📌</span>}</div>
                  <span className={`title-wrap notice-title ${index < topListCount ? 'top-notice-title' : ''}`}>
                    {item.title}
                    {item.isRecent && (
                      <span
                        className={`new-notice ${
                          item.isRead || readPostIds.includes(item.id.toString()) ? 'read-notice' : ''
                        }`}
                      >
                        New
                      </span>
                    )}
                  </span>
                  {isMobile && (
                    <span className="file-wrap notice-file">
                      {item.fileCount && item.fileCount > 0 ? (
                        <AttachFileOutlined
                          fontSize="small"
                          sx={{
                            color: '#999999',
                            marginLeft: '0.25rem',
                            marginBottom: '-0.125rem',
                          }}
                        />
                      ) : (
                        ''
                      )}
                    </span>
                  )}
                  <span className="date-wrap notice-date">{dayjs(item.createdAt).format('YYYY-MM-DD')}</span>
                  {isMobile || (
                    <span className="file-wrap notice-file">
                      {item.fileCount && item.fileCount > 0 ? (
                        <AttachFileOutlined
                          fontSize="small"
                          sx={{
                            color: '#999999',
                            marginLeft: '0.25rem',
                            marginBottom: '-0.125rem',
                          }}
                        />
                      ) : (
                        ''
                      )}
                    </span>
                  )}
                </Link>
              </li>
            ))}
          </ol>
          {listCount > 10 && (
            <Pagination
              total={listCount}
              limit={10}
              currentPage={parseInt(page)}
              paginate={async (page) => {
                await setCurrentPage(page);
                if (page === 1) history.push('/notices');
                else history.push(`/notices?page=${page}`);
              }}
            />
          )}
        </div>
      </div>
    </Main>
  );
};

export default Notice;
